/*
 * @Author: liyifan
 * @Date: 2024-06-19 16:46:32
 * @Last Modified by: liyifan
 * @Last Modified time: 2024-08-30 14:58:35
 * @description: 首页-媒体背书
 */
import { isMobile  } from '@utils/index.js'
export class AwardsSwiper {
    constructor() {
        this.init();
    }
    init() {
        const awardsSwiperDom = $('.awards-swiper');
        if (awardsSwiperDom.length === 0) return
        const awardsSwiper =  new Swiper(".awards-swiper", {
            spaceBetween: 16,
            slidesPerView: 1.2,
            autoplay: isMobile() ? false : {
                delay: 0,
                disableOnInteraction: false,
                // pauseOnMouseEnter: true
            },
            freeMode: !isMobile(),
            speed: isMobile() ? 600 : 3000,
            allowTouchMove: isMobile(),
            simulateTouch: false,
            loop: true,
            breakpoints: {
                1024: {
                    spaceBetween: 20,
                    slidesPerView: 3,
                },
            },
            pagination: {
                el: ".awards-pagination",
            },
            on: {
                slideChangeTransitionEnd: function () {
                    // 防止轮播懒加载白屏
                    const currSlide = Array.from(this.slides).filter((it) =>
                        it.classList.contains("swiper-slide")
                    );

                    const currImg = currSlide[0].querySelector(".award-item-img");
                    if (currImg && currImg.classList.contains('lazyloading')) {
                        currImg.classList.remove("lazyloading");
                        currImg.classList.add("lazyloaded");
                    }
                },
            }
        });

        let nextTransForm = ''
        let nextTime = 0

        const swiperWrapper = document.getElementsByClassName('awards-swiper')[0]?.querySelector('.swiper-wrapper')
        if (swiperWrapper) {
            awardsSwiper.el.onmouseenter = function () {
                nextTransForm = swiperWrapper.style.transform

                let nextTransPosition = -1 * parseInt(swiperWrapper.style.transform.split("translate3d(")[1].split('px')[0])
                let nowTransPosition = -1 * parseInt(
                    window.getComputedStyle(swiperWrapper, false)["transform"].split("1, ")[2].split(",")[0]
                )
                let nowTransForm = window.getComputedStyle(swiperWrapper, false)["transform"]


                const slideWidth = swiperWrapper?.querySelector('.swiper-slide').style.width?.split('px')[0]
                nextTime = 3000 * ((nextTransPosition - nowTransPosition) / Number(slideWidth))
                swiperWrapper.style.transform = nowTransForm
                swiperWrapper.style.transitionDuration = "0ms"
                awardsSwiper.autoplay.stop()
            }

            awardsSwiper.el.onmouseleave = function () {
                swiperWrapper.style.transform = nextTransForm
                swiperWrapper.style.transitionDuration = `${nextTime}ms`
                awardsSwiper.autoplay.start()
            }
        }
    }
}
